import React from "react";
import { Link } from "react-router-dom";
import PageShell from "@/components/proof/PageShell";

export default function NotFound() {
    return (
        <PageShell
            sectionNumber="--"
            eyebrow="Off the field"
            title="Not Found"
            crumb="404"
            data-testid="page-notfound"
        >
            <p
                style={{
                    margin: 0,
                    fontFamily: "'EB Garamond', serif",
                    fontStyle: "italic",
                    fontSize: 21,
                    color: "rgba(255,255,255,0.65)",
                    maxWidth: "44ch",
                    marginBottom: 28,
                }}
            >
                The signal is silent here. The page you tried to reach was
                never built, or has been moved.
            </p>
            <Link
                to="/"
                data-testid="notfound-home"
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 12,
                    color: "#fff",
                    textDecoration: "none",
                    border: "1px solid rgba(255,255,255,0.45)",
                    padding: "14px 26px",
                    fontFamily: "JetBrains Mono, monospace",
                    fontSize: 11,
                    letterSpacing: "0.28em",
                    textTransform: "uppercase",
                }}
            >
                Return to Home
            </Link>
        </PageShell>
    );
}
